<template>
    <v-container fluid>

        <v-row>
            <v-col>
                현재 로그인 유저 : {{loginName}} <span v-if="isStudent">학생</span><span v-else-if="!isStudent">강사</span>
            </v-col>
            <v-col>
                <v-text-field
                        v-model="loginName"
                        label="학생이름"
                        outlined
                ></v-text-field>
            </v-col>
            <v-col>
                <v-btn @click="loginStudent(loginName)">학생 로그인하기</v-btn>
                <v-btn @click="loginTeacher(loginName)">강사 로그인하기</v-btn>
            </v-col>
        </v-row>

        <!-- 강사 로그인 했을때 -->
        <div v-if="!isStudent">
            <v-row>
                <v-col>
                    <v-text-field
                            v-model="courseName"
                            label="코스이름"
                            outlined
                    ></v-text-field>
                </v-col>
                <v-col>
                    <v-btn @click="registerCourse(courseName)">코스등록</v-btn>

                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    <v-text-field
                            v-model="labName"
                            label="랩 이름"
                            outlined
                    ></v-text-field>
                </v-col>
                <v-col>
                    <v-btn @click="registerLab(courseName, labName)">랩 등록</v-btn>
                </v-col>
            </v-row>



            <v-row>
                <v-col>
                    <v-text-field
                            v-model="clazzName"
                            label="클래스 이름"
                            outlined
                    ></v-text-field>
                </v-col>
                <v-col>
                    <v-btn @click="registerClazz(courseName, clazzName)">클래스 등록</v-btn>
                </v-col>
            </v-row>

        </div>


        <!-- 학생 로그인 했을때 -->
        <div v-if="isStudent">
            <v-row>
                <v-col>
                    <v-text-field
                            v-model="courseName"
                            label="코스이름"
                            outlined
                    ></v-text-field>
                </v-col>
                <v-col>
                    <v-text-field
                            v-model="clazzName"
                            label="클래스 이름"
                            outlined
                    ></v-text-field>
                </v-col>
                <v-col>
                    <v-text-field
                            v-model="labName"
                            label="랩 이름"
                            outlined
                    ></v-text-field>
                </v-col>
                <v-col>
                    <v-btn @click="joinLab(labName)">랩 조인</v-btn>
                </v-col>
            </v-row>

            <v-row>
                <v-label>내가 등록한 클래스</v-label>
            </v-row>

            <v-row v-for="(clazz, index) in myClazzList" :key="index">
                {{clazz}}
            </v-row>

        </div>

        <v-row>
            <v-label>코스 목록</v-label>
        </v-row>

        <v-row v-for="(course, index) in courseList" :key="index">
            {{course}}
        </v-row>

        <v-row>
            <v-label>잠시 테스트</v-label>
        </v-row>

        <v-row v-for="(course, index) in labList" :key="index">
            {{course}}
        </v-row>

        <v-row>
            <v-label>클래스 목록</v-label>
        </v-row>

        <v-row v-for="(clazz, index) in clazzList" :key="index">
            {{clazz}}
        </v-row>
    </v-container>

</template>

<script>

    var Minio = require('minio');

    export default {
        name: "labAdminTest",

        components: {},

        data: () => ({
            userName: "sanghoon",
            userGroup: "gmail",
            clazz: 'uengine',


            courseName: 'kubernetes',
            labName: 'lab1',
            clazzName: 'sk1st',
            loginName: 'uengine1@uengine.org',
            isStudent : false,

            minioClient : null,
            courseList: {},
            labList: null,
            clazzList: {},
            myClazzList: {},
            overlay: false
            //
        }),
        computed: {
            loadingStatus() {
                if (Object.keys(this.courseList).length < 1) {
                    return true
                } else {
                    return false
                }
            },
        },
        mounted() {
            var me = this
            var minioClient = new Minio.Client({
                endPoint: "minio.msaez.io",
                port: 443,
                useSSL: true,
                accessKey: "minio",
                secretKey: "minio123"
            });
            me.$minioClient = minioClient
            me.courseLists()
            me.clazzLists()
        },
        methods: {
            /**
             * 등록되어있는 코스 리스트를 가져옴
             */
            courseLists(){
                var me = this
                me.labList = new Map()
                var stream = me.$minioClient.listObjectsV2('labs', '', true, '')
                stream.on('data', function (obj) {
                    console.log(obj.name)
                    var tmp = obj.name.split('/');
                    var course = tmp[0];
                    var name = obj.name
                    if( tmp[1] == 'planed' ){
                        var labName = tmp[2]
                        var json = {
                            "강좌 이름" : course,
                            "랩 이름" : labName
                        }
                        if( me.labList.has(course)){
                            var tmpArray = me.labList.get(course)
                            tmpArray.push(json)
                        }else{
                            me.labList.set(course , [json] )
                        }

                        me.$set(me.courseList, course+'_'+labName, json)
                    }
                })
                stream.on('error', function (err) {
                    console.log(err)
                })
            },
            /**
             * 현재 진행중인 클래스 리스트를 가져옴
             */
            clazzLists(){
                var me = this
                var stream = me.$minioClient.listObjectsV2('labs', '', true, '')
                stream.on('data', function (obj) {
                    console.log(obj.name)
                    var tmp = obj.name.split('/');
                    var course = tmp[0];
                    if( tmp[1] == 'runningClass' ){

                        var clazzName = tmp[2]
                        var json = {
                            "강좌이름" : course,
                            "클래스이름" : clazzName,
                            "포함된 랩" : ''
                        }
                        me.$set(me.clazzList, course+'_'+clazzName, json)
                    }
                })
                stream.on('error', function (err) {
                    console.log(err)
                })
            },
            /**
             * 내가 조인한 클래스 리스트를 가져옴
             */
            myClazzLists(){
                var me = this
                var stream = me.$minioClient.listObjectsV2('labs', '', true, '')
                stream.on('data', function (obj) {
                    console.log(obj.name)
                    var tmp = obj.name.split('/');
                    var course = tmp[0];
                    if( tmp[1] == 'runningClass' ){
                        // TODO
                    }
                })
                stream.on('error', function (err) {
                    console.log(err)
                })
            },
            registerCourse(courseName) {
                var me = this

                me.$minioClient.putObject('labs', `${courseName}/Course_Metadata.json`, '', {
                    'Content-Type': 'application/json',
                } , function (err, etag) {
                    me.courseLists()
                    return console.log(err, etag)
                });
            },
            registerLab(courseName, labName) {
                var me = this
                me.$minioClient.putObject('labs', `${courseName}/planed/${labName}/Lab_Metadata.json`, '', {
                    'Content-Type': 'application/json',
                } , function (err, etag) {
                    me.courseLists()
                    return console.log(err, etag)
                });

            },
            /**
             * 강사가 클래스를 만듬
             */
            registerClazz(courseName, clazzName) {
                var me = this
                me.$minioClient.putObject('labs', `${courseName}/runningClass/${clazzName}/Class_Metadata.json`, '', {
                    'Content-Type': 'application/json',
                } , function (err, etag) {
                    me.clazzLists()
                    return console.log(err, etag)
                });
            },
            /**
             * 학생이 클레스를 조인함
             */
            joinClazz(clazzName) {
                var me = this
                me.$minioClient.putObject('labs', `${me.courseName}/runningClass/${clazzName}/Class_Metadata.json.json`, '', {
                    'Content-Type': 'application/json',
                } , function (err, etag) {
                    return console.log(err, etag)
                });

            },
            /**
             * 학생이 랩에 조인함
             */
            joinLab(labName) {
                var me = this
                // TODO
                // 렙에 있는 기본 데이터가 코스/runningClass/클래스이름/랩이름/유저이름/ 아래로 복사가 되어야함.

                var json = {
                    labPass : false
                }
                me.$minioClient.putObject('labs', `${me.courseName}/runningClass/${me.clazzName}/${labName}/${me.loginName}/User_Lab_Metadata.json`,
                    JSON.stringify(json),
                    {'Content-Type': 'application/json'} ,
                    function (err, etag) {
                        return console.log(err, etag)
                    }
                );

            },
            loginStudent(loginName) {
                this.isStudent = true
                this.myClazzList = {}
                this.myClazzLists()
            },
            loginTeacher(loginName) {
                this.isStudent = false
            }
        }
    }
</script>

<style scoped>

</style>